import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    unexpectedError: 'An unexpected error has ocurred.',
  },
})
